import { promotionV2Page } from 'utils/pageTemplates/promotionV2Page';

const { getStaticProps, getStaticPaths, PromotionV2PageComponent } =
  promotionV2Page();

export { getStaticPaths, getStaticProps };
export default PromotionV2PageComponent;
